<template>
  <WithBackdrop
    :class="[$style.config, $style.wrap]"
    :backdrop="data?.fields?.backdrop"
    :style="data?.fields?.cssOverride"
  >
    <div :class="$style.inner">
      <BaseHeading
        v-if="data?.fields?.header"
        :class="$style.header"
        size="h2"
        as="h3"
      >
        {{ data?.fields?.header }}
      </BaseHeading>
      <div :class="$style.layout">
        <div :class="$style.contentContainer">
          <MarkedParser :class="$style.copy" :md="data?.fields?.subheader" />

          <div
            v-if="data?.fields?.references?.filter?.(instanceOfMedia)?.length"
            :class="$style.cards"
          >
            <MediaCard
              v-for="a in data?.fields?.references?.filter?.(instanceOfMedia)"
              :key="a?.sys?.id"
              :data="a"
            />
          </div>

          <MarkedParser :class="$style.copy" :md="data?.fields?.copy" />

          <div v-if="data?.fields?.ctas?.length">
            <CallToAction
              v-for="c in data?.fields?.ctas"
              :key="c?.sys?.id"
              :cta="c"
            />
          </div>
        </div>

        <div :class="$style.cardContainer">
          <template v-for="card in data?.fields?.cards">
            <AsideCard v-if="card" :key="card?.sys?.id" :data="card" />
          </template>
        </div>
      </div>
    </div>
  </WithBackdrop>
</template>

<script setup lang="ts">
import type { TypeMediaListingWithoutUnresolvableLinksResponse } from '~/types/contentful'

defineProps<{
  data: TypeMediaListingWithoutUnresolvableLinksResponse
}>()
</script>

<style lang="scss" module>
.wrap {
  position: relative;
  background: var(--gray-1);
}

.inner {
  max-width: 1350px;
  padding: 45px 20px 50px;
  margin: auto;
}

.layout {
  display: grid;
  gap: 50px;
  align-items: flex-start;

  @include media('sm') {
    grid-template-columns: 60% 1fr;
    gap: 30px;
  }

  @include media('md') {
    grid-template-columns: 1fr minmax(28%, 336px);
    gap: 66px;
  }
}

.contentContainer {
  color: var(--gray-8);
  text-align: center;

  @include media('sm') {
    text-align: left;
  }
}

.headerContainer {
  max-width: 544px;
  margin: 0 auto 22px;

  @include media('sm') {
    margin-left: 0;
  }
}

.header {
  text-align: center;
  margin-bottom: 18px;

  @include media('sm') {
    text-align: left;
  }
}

.subheader {
  @include fluid-type(16px, 22px);
  font-family: var(--georgia);
  line-height: math.div(32, 22);
}

.copy {
  @include fluid-type(16px, 19px);
  line-height: math.div(30, 19);
  margin-bottom: 20px;

  p {
    margin-bottom: 20px;
  }
}

.cards {
  display: grid;
  grid-template-columns: 1fr;
  gap: 17px;
  margin-bottom: 20px;
}

.card {
  --padding--base: 0;
  --padding--lg: 0;
}

.cta {
  margin-top: 40px;
}

.cardContainer {
  display: grid;
  gap: 19px;
}
</style>
